<template>
  <div id="app">
    <!-- <banner-environment/> -->
    <!-- <br /> -->
    <layout-broker :name="layout">
      <router-view />
    </layout-broker>
  </div>
</template>

<script>
import LayoutBroker from '@/layouts/broker'
import BannerEnvironment from '@/components/navigation/banner-environment'

export default {
  name: 'app',
  components: {
    LayoutBroker,
    BannerEnvironment
  },
  computed: {
    layout() {
      return this.$route.meta && this.$route.meta.layout
        ? this.$route.meta.layout
        : 'no-nav'
    }
  }
}
</script>

<style lang="scss">
@import '../node_modules/@fortawesome/fontawesome-free/css/all.min.css';
@import '../node_modules/vue-multiselect/dist/vue-multiselect.min.css';
@import '../src/assets/sass/custom.scss';
</style>



// WEBPACK FOOTER //
// src/App.vue